import {
  Alert,
  AlertDescription,
  AlertTitle,
  Button,
  Divider,
  FormControl,
  HStack,
  Icon,
  IconButton,
  Link,
  Text,
} from '@chakra-ui/react';
import React, { useContext, useEffect, useState } from 'react';
import { Stack } from '@chakra-ui/layout';
import { useHistory } from 'react-router';
import { useForm } from 'react-hook-form';
import { Card } from '~/components/Card';
import { UpdateCalculation } from '~/types/terminationRequests';
import { InputFloat } from '~/components/InputFloat';
import { formatCurrency } from '~/utils/formatCurrency';

export const TotalValuesContract: React.VFC<{
  data?: UpdateCalculation;
  visualizacao: boolean;
  changeContractValue?: (valor: number, field: string) => void;
}> = ({ changeContractValue, visualizacao, data }) => {
  const [fechado, setFechado] = useState(false);
  const history = useHistory();
  const { setError, clearErrors, formState } = useForm();
  const { errors } = formState;
  const [descontoControl, setDesconto] = useState(data?.desconto || 0);
  const [dataControl, setData] = useState(data);

  useEffect(() => {
    setData(data);
  }, [data]);

  const handleChange = (e: number, field: string) => {
    clearErrors('desconto');
    const v = e.toString().replace(/\D/g, '');
    if (v.length > 12) {
      return;
    }

    changeContractValue && changeContractValue(e, field);
  };

  const formataNumberStrToFloat = (value: string) => {
    const v = value.replace('.', '').replace('R$', '');
    return Number(v.replace(',', '.'));
  };

  const totcontent = () => {
    return (
      <Stack justifyContent="flex-end">
        <HStack justifyContent="flex-end">
          <Text fontWeight="bold">Valor total:</Text>
          <Text fontSize="18px" fontWeight="bold" w="200px" textAlign="right">
            {formatCurrency(dataControl?.valor_total || 0)}
          </Text>
        </HStack>
        {!visualizacao && (
          <HStack justifyContent="flex-end" alignItems="baseline">
            <Text fontWeight="bold">Desconto (%):</Text>
            <FormControl isInvalid={errors.desconto} w="200px">
              <InputFloat
                isRequired
                error={errors.desconto}
                type="text"
                size="sm"
                textAlign="right"
                fontSize="15px"
                value={descontoControl}
                name="desconto"
                onChangeValue={e => {
                  handleChange(e, 'desconto');
                }}
              />
            </FormControl>
          </HStack>
        )}
        {visualizacao && (
          <HStack justifyContent="flex-end">
            <Text fontWeight="bold">Desconto (%):</Text>
            <Text fontSize="18px" fontWeight="bold" w="200px" textAlign="right">
              {dataControl?.desconto || '0,00'}
            </Text>
          </HStack>
        )}
        <Divider borderColor="purple.400" />
        <HStack justifyContent="flex-end">
          <Text fontWeight="bold">Valor total geral para rescisão:</Text>
          <Text fontSize="18px" fontWeight="bold" w="200px" textAlign="right">
            {formatCurrency(dataControl?.valor_total_geral || 0)}
          </Text>
        </HStack>
      </Stack>
    );
  };

  return (
    <Card
      content={totcontent()}
      width="65%"
      minW="65%"
      backgroundColor="purple.50"
    />
  );
};
